<div class="building-icon" (mouseenter)="hoverLegendEvent(true)" (mouseleave)="hoverLegendEvent(false)">
  <img class="building-icon-image" [src]="iconImageUrl" alt="building-icon" />
  <div class="energy-guard-shield-icon">
    <app-shield-guard-icon
      *ngIf="!!authService.permissions.ENERGY_GUARD && hasLicensedMetersMunicipalityLvl"
      [ngClass]="isUnknownBuildingType ? 'unknown-building-type-shield-icon' : 'shield-icon'"
      [isMeterLicensed]="isMeterLicensed"
      [badgeVisible]="badgeVisible"
      [(alarmCount)]="alarmCount"
      [isIconForHomeScreen]="false"
      [isIconForMapScreen]="true"
    >
    </app-shield-guard-icon>
    <span *ngIf="!!tooltipText" [ngClass]="{ 'unknown-building-type-tooltip': isUnknownBuildingType, tooltiptext: !!authService.permissions.ENERGY_GUARD }">{{
      tooltipText
    }}</span>
  </div>
  <div class="efficiency-analysis" *ngIf="!isEfficiencyDisabled">
    <div class="effiency-analysis-legend" *ngIf="isBuildingHovered && (electricityColorStatus || heatColorStatus)">
      <span>
        <img alt="strom-img" class="legend-icon" title="Strom" src="./assets/icons/ico_electricity_2.svg" />
        Strom
      </span>
      <span>
        <img alt="warme-img" class="legend-icon" title="Wärme" src="./assets/icons/ico_heat_2.svg" />
        Wärme
      </span>
    </div>
    <div class="left-circle" *ngIf="electricityColorStatus">
      <svg
        class="left-circle-svg"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 88 104"
        style="enable-background: new 0 0 88 104"
        xml:space="preserve"
      >
        <style type="text/css">
          .st0 {
            fill: #bff430;
          }

          .st1 {
            fill: #ffffff;
          }
        </style>
        <g id="Component_24_7" transform="translate(5 5)">
          <g id="Path_16" transform="translate(465.913 -4355.043)">
            <path
              [attr.fill]="electricityColorStatus"
              d="M-390,4446.1h-2.2c-19.2,0-37.1-4.4-50.5-12.4c-3.2-2-6.2-4.1-8.8-6.4c-2.6-2.3-4.9-4.9-6.7-7.5
			c-1.9-2.7-3.3-5.6-4.3-8.5c-1-3-1.5-6.1-1.5-9.2s0.5-6.2,1.5-9.2c1-2.9,2.4-5.8,4.3-8.5c1.8-2.6,4.1-5.2,6.7-7.5
			c2.6-2.3,5.5-4.5,8.8-6.4c13.3-8,31.2-12.4,50.5-12.4h2.2v2.2v6.4v2.2h-2.2c-16.6,0-32.1,3.6-43.8,10.1
			c-11.2,6.3-17.4,14.5-17.4,23.1s6.2,16.8,17.4,23.1c11.7,6.5,27.2,10.1,43.8,10.1h2.2v2.2v6.4V4446.1z"
            />
            <path
              class="st1"
              d="M-392.2,4360.2c-38.9,0-69.4,18.4-69.4,41.8c0,23.5,30.5,41.8,69.4,41.8v-6.4c-35,0-63.4-15.9-63.4-35.5
			s28.4-35.5,63.4-35.5V4360.2 M-392.2,4355.8h4.4v4.5v6.4v4.5h-4.4c-16.2,0-31.4,3.5-42.7,9.8c-10.5,5.9-16.3,13.4-16.3,21.2
			c0,7.8,5.8,15.3,16.3,21.2c11.3,6.3,26.5,9.8,42.7,9.8h4.4v4.4v6.4v4.5h-4.4c-19.6,0-38-4.5-51.6-12.8c-6.9-4.1-12.3-9-16.1-14.6
			c-2-2.9-3.5-5.9-4.5-9c-1.1-3.2-1.6-6.6-1.6-9.9s0.5-6.7,1.6-9.9c1-3.1,2.6-6.2,4.5-9c3.8-5.5,9.2-10.4,16.1-14.6
			C-430.2,4360.3-411.8,4355.8-392.2,4355.8z"
            />
          </g>
        </g>
      </svg>
    </div>
    <div class="right-circle" *ngIf="heatColorStatus">
      <svg class="right-circle-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 78.32 92.58">
        <defs>
          <style>
            .cls-1 {
              fill: #f3463f;
            }

            .cls-2 {
              fill: #fff;
            }
          </style>
        </defs>
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_1-2" data-name="Layer 1">
            <g id="Component_23_7" data-name="Component 23 7">
              <g id="Path_17" data-name="Path 17">
                <path
                  [attr.fill]="heatColorStatus"
                  d="M4.45,90.36H2.23V79.52H4.45c16.57,0,32.12-3.59,43.78-10.1,11.25-6.29,17.44-14.5,17.44-23.13S59.48,29.45,48.23,23.16C36.57,16.65,21,13.06,4.45,13.06H2.23V2.23H4.45c19.23,0,37.15,4.41,50.46,12.44a57.28,57.28,0,0,1,8.75,6.42,43,43,0,0,1,6.67,7.5,33.55,33.55,0,0,1,4.27,8.47,29.15,29.15,0,0,1,0,18.46A33.55,33.55,0,0,1,70.33,64a43,43,0,0,1-6.67,7.5,57.28,57.28,0,0,1-8.75,6.42C41.6,85.94,23.68,90.36,4.45,90.36Z"
                />
                <path
                  class="cls-2"
                  d="M4.45,4.45v6.39c35,0,63.45,15.87,63.45,35.45S39.49,81.74,4.45,81.74v6.39c38.93,0,69.42-18.38,69.42-41.84S43.38,4.45,4.45,4.45M0,0H4.45C24.08,0,42.4,4.53,56.06,12.76a51.44,51.44,0,0,1,16.1,14.57,35.48,35.48,0,0,1,4.55,9,31.43,31.43,0,0,1,0,19.86,35.48,35.48,0,0,1-4.55,9,51.44,51.44,0,0,1-16.1,14.57c-13.66,8.23-32,12.76-51.61,12.76H0V77.29H4.45c16.2,0,31.36-3.49,42.69-9.82C57.66,61.6,63.45,54.08,63.45,46.29S57.66,31,47.14,25.11c-11.33-6.33-26.49-9.82-42.69-9.82H0V0Z"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  </div>
</div>
